import Figma from './Figma'

type IntegrationType = 'figma' | 'slack' | null

const TYPES = {
  figma: Figma,
  slack: null,
}

class IntegrationProvider {
  private type: IntegrationType = null

  constructor(type: IntegrationType) {
    this.type = type
  }

  authenticate() {
    const type = this.get()

    if (type) {
      return type.authenticate()
    }
  }

  authorize(state: { [key: string]: any } = {}) {
    const type = this.get()

    if (type) {
      return type.authorize(state)
    }
  }

  private get() {
    return TYPES[this.type || 'figma']
  }
}

export default IntegrationProvider
